<template>
    <div id="telethon">
        <main class="main">
            <div class="tv-test-card">
                <div id="black"></div>
                <div id="red"></div>
                <div id="pink"></div>
                <div id="green"></div>
                <div id="blue"></div>
                <div id="yellow"></div>
                <div id="white"></div>
            </div>
            <div class="title-container">
                <div class="overlay-container pulsing-border">
                    <h3 class="overlaid-text overlay">A global fundraiser celebrating 15 epic years of Performa</h3>
                    <!-- <prismic-rich-text class="overlaid-text overlay" :field="telethonDesc.primary.section_text" /> -->
                    <img :src="telethonImg" class="overlay grow-subtle" />
                    <h2 class="overlay">
                        {{ date }}
                        <br />
                        2PM - 10PM EST
                    </h2>
                </div>
                <figure class="featured-image">
                    <prismic-image :field="fields.featured_image"/>
                </figure>
            </div>
            <div>
            <div class="tv-test-card">
                <div id="black"></div>
                <div id="red"></div>
                <div id="pink"></div>
                <div id="green"></div>
                <div id="blue"></div>
                <div id="yellow"></div>
                <div id="white"></div>
            </div>
            </div>
            <template v-for="(ticker) in tickers.slice(0,2)">
	            <div class="ticker loaded black-ticker" :data-title="ticker.primary.ticker_text" :key="ticker.primary.ticker_text">
			        <div>
			  	        <marquee-text :duration="60">
			  	            <span class="ticker-item blue fs-normal">{{ ticker.primary.ticker_text }}</span>
			  	            <span class="ticker-item blue performa fs-normal">Performa</span>
			  	            <span class="ticker-item blue fs-normal">{{ ticker.primary.ticker_text }}</span>
			  	            <span class="ticker-item blue performa fs-normal">Performa</span>
			  	        </marquee-text>
			        </div>
	            </div>
            </template>
            <article class="credits grid-container c2">
                <div>
                    <h3>Honoring Founding Perfoma Board Member</h3>
                    <h2><strong>Toby Devan Lewis</strong></h2>
                </div>
                <div>
                    <h3>Dedicated To</h3>
                    <h2><strong>Nam June Paik</strong></h2>
                </div>
            </article>
            <div class="tv-test-card">
                <div id="black"></div>
                <div id="red"></div>
                <div id="pink"></div>
                <div id="green"></div>
                <div id="blue"></div>
                <div id="yellow"></div>
                <div id="white"></div>
            </div>
            <article class="section-info sticky grid-container c2">
                <figure>
                    <prismic-image :field="sectionImg" />
                </figure>
                <div class="page-content wrap">
                    <!-- <a class="btn btn-white">Join The Committee</a> -->
                    <template v-for="(slice, index) in slices">
		                <template v-if="slice.slice_type === 'title'">
			                <article class="breadcrumb-trigger" :data-title="slice.primary.section_title" ref="sanitizeTitle(slice.primary.section_title).toString()">
					            <h2 class="text-condensed text-uppercase text-left" :id="sanitizeTitle(slice.primary.section_title)"><strong>{{ slice.primary.section_title }}</strong></h2>
			                </article>
		                </template>
		                <template v-if="slice.slice_type === 'text'">
			                <article class="text">
					            <prismic-rich-text :field="slice.primary.section_text" :class="slice.primary.section_text_class"/>
			                </article>
		                </template>
		                <template v-else-if="slice.slice_type === 'carousel'">
			                <carousel :adjustableHeight="true" :autoplay="true" :loop="true" :centerMode="true" :per-page="1" paginationColor="#ffffff" :paginationSize="8" :paginationPadding="4" :speed="250":autoplayTimeout="5000">
				                <slide v-for="(item, index) in slice.items" class="carousel-slide" :key="item.id">
					            <figure class="img" @click="showPhotoSwipe(index)">
					                <picture>
						            <!-- <source :srcset="item.slide_image.mobile.url" media="(max-width: 767px)"> -->
					                    <img :src="item.slide_image.url">
					                </picture>
	                                <figcaption>
                                        <prismic-rich-text :field="item.slide_caption" :htmlSerializer="innerSingleParagraph"/>
	                                </figcaption>
					            </figure>
	                            </slide>
			                </carousel>
		                </template>
		                <template v-else-if="slice.slice_type === 'image_grid'">
			                <div class="grid-container c3 image-grid">
				                <div v-for="(item, x) in slice.items" class="grid-image" v-lazy-container="{ selector: 'img' }">
					                <figure class="img img-landscape" @click="showPhotoSwipe(index)">
					                    <img :data-src="item.grid_image.url">
	                                    <figcaption>
                                            <prismic-rich-text :field="item.grid_image_caption" :htmlSerializer="innerSingleParagraph"/>
                                        </figcaption>
					                </figure>
				                </div>
			                </div>
		                </template>
		                <template v-else-if="slice.slice_type === 'cta'">
		    	            <article>
			    	            <template v-for="(item, index) in slice.items">
				    	            <prismic-link :field="item.cta_link" class="cta btn">
				    	                <span>{{ item.cta_text }}</span>
				    	            </prismic-link>
			    	            </template>
		    	            </article>
		                </template>
		                <template v-else-if="slice.slice_type === 'video'">
			                <article class="article-video">
				                <figure class="img"   :class="[muted ? 'muted' : '']">					    
    			                    <div class="rb-video-wrap video-wrap"  @click="toggleMuted">
	                                    <video id="rb-video" playsinline="" autoplay="" loop="" :muted="muted" preload="auto">
	          	                            <source :src="slice.primary.video_link.url" type="video/mp4">
	                                    </video>
                                    </div>
                                    <figcaption><prismic-rich-text :field="slice.primary.video_caption" :htmlSerializer="innerSingleParagraph"/></figcaption>
				                </figure>
			                </article>
		                </template>
		                <!-- <template v-else-if="slice.slice_type === 'image_banner'">
			                <figure class="img">
                                <figcaption><prismic-rich-text :field="slice.primary.banner_caption" :htmlSerializer="innerSingleParagraph"/></figcaption>
                            </figure>
		                </template> -->
		                <template v-else-if="slice.slice_type === 'horizontal_break'">
			                <article>
			                    <hr>
			                </article>
		                </template>
		                <template v-else-if="slice.slice_type === 'pull_quote'">
			                <article>
				                <aside class="pquote">
				                    <blockquote>
				                        <prismic-rich-text :field="slice.primary.quote_text" :htmlSerializer="innerSingleParagraph"/>
				                    </blockquote>
				                    <template v-if="slice.primary.quote_author">
				                        <prismic-rich-text :field="slice.primary.quote_author" :htmlSerializer="innerSingleParagraph" class="pquote-author"/>
				                    </template>
						        </aside>
			                </article>
		                </template>
		                <template v-else-if="slice.slice_type === 'expander'">
			                <article>
				                <ul class="grid-list text-smaller">
					    
					                <Expander v-for="(item, index) in slice.items" :key="item.id" :expander="item">
		                            </Expander>
				                </ul>
			                </article>
 		                </template>
	                    <template v-else-if="slice.slice_type === 'code_snippet'">
	    	                <article v-html=$prismic.richTextAsPlain(slice.primary.code_snippet)  ></article>
	                    </template>	    
	                </template>
                </div>
            </article>
            <template v-for="(ticker) in tickers.slice(2)">
	            <div class="ticker loaded blue-ticker" :data-title="ticker.primary.ticker_text" :key="ticker.primary.ticker_text">
			        <div>
			  	        <marquee-text :duration="60">
			  	            <span class="ticker-item white fs-normal">{{ ticker.primary.ticker_text }}</span>
			  	            <span class="ticker-item white performa fs-normal">Performa</span>
			  	            <span class="ticker-item white fs-normal">{{ ticker.primary.ticker_text }}</span>
			  	            <span class="ticker-item white performa fs-normal">Performa</span>
			  	        </marquee-text>
			        </div>
	            </div>
            </template>
            <div class="tv-test-card">
                <div id="black"></div>
                <div id="red"></div>
                <div id="pink"></div>
                <div id="green"></div>
                <div id="blue"></div>
                <div id="yellow"></div>
                <div id="white"></div>
            </div>
            <article class="footer-info grid-container c2">
                <div class="wrap">
                    <h2><strong>Board Of Directors</strong></h2>
                    <p>
                        Todd Bishop, Richard Chan — President, Wendy Fisher, RoseLee Goldberg — Founding Director, Ronald Guttman,
                        David Hallberg, Barbara Hoffman — Secretary, Rashid Johnson — Vice President, Toby Devan Lewis — Emeritus Chair,
                        Joyce Liu, Shirin Neshat, Ivan Pun, Jeanne Greenberg Rohatyn, Lisa Schiff, Roya Sachs, Neil Wenman
                    </p>
                </div>
                <div class="wrap">
                    <h2><strong>About Performa</strong></h2>
                    <p>
                        Founded in 2004 by art historian and curator RoseLee Goldberg, Performa is the leading organization dedicated to exploring the 
                        critical role of live performance in the history of twentieth–century art and to encouraging new directions in performance for 
                        the twenty–first century. 2020 marks the 15th Anniversary of Performa and the celebration of the past eight biennials and the 
                        hundreds of artists engaged throughout that time. Stay tuned for details about the Performa 21 Biennial, to take place in October 
                        2021 in New York City.
                    </p>
                </div>
            </article>
        </main>
    </div>
</template>

<script>
import prismicDOM from 'prismic-dom';
import moment from 'moment';

import snowImage from '../assets/img/snow.jpg'

import Expander from '../components/Expander.vue';

const Elements = prismicDOM.RichText.Elements;


const telethonImage = require('@/assets/img/performa-telethon.png');

export default {

    components: {
        Expander
    },

    computed: {
        telethonDesc() {
            return this.slices[1];
        },

        sectionImg () {
            return this.slices.find(slice => slice.slice_type === 'image').primary.section_image;
        },

        date () {
            return moment(this.fields.date).format('MMMM DD, YYYY')
        }
    },

    data () {
        return {
            documentId: '',
            loading: true,
            telethonImg: telethonImage,
            fields: {
	            uid: null,
                title: null,
                date: null,
                description: null,
                template: null,
                featured_image: null,
                featured_image_caption: null,
                desktop_featured_image_crop_point: null
            },
            slices: [],
            tickers: [],
            muted: true,
            mounted: false,
            isOpen: false,
            isOpenGallery: false,
            options: {
                index: 0,
                showHideOpacity: true,
                history: false
            },
            optionsGallery: {},
            items: []
        }
    },

    methods: {
        async getContent() {
            try {
                const document = await this.$prismic.client.getByUID('page', 'telethon');
                this.documentId = document.id
                this.fields.uid = document.uid
                this.fields.title = document.data.title
                this.fields.date = document.data.date
                this.fields.description = document.data.seo_description
                this.fields.template = document.data.template
				this.fields.featured_image = document.data.featured_image
				this.fields.featured_image_url = document.data.featured_image.url
				this.fields.featured_image_caption = document.data.featured_image_caption
				this.fields.desktop_featured_image_crop_point = document.data.desktop_featured_image_crop_point
                this.slices = document.data.body
	            this.tickers = document.data.body1
	          
	            this.items.push({
		          src: document.data.featured_image.url,
		          w: document.data.featured_image.dimensions.width,
		          h: document.data.featured_image.dimensions.height,
		          title: prismicDOM.RichText.asHtml(document.data.featured_image_caption),
		          index: 0
		        })
            
                for (var [i, slice] of this.slices.entries()) {
	            
						  if (slice.slice_type == 'image') {
							  this.items.push({
				          src: slice.primary.section_image.url,
				          w: slice.primary.section_image.dimensions.width,
				          h: slice.primary.section_image.dimensions.height,
				          title: prismicDOM.RichText.asHtml(slice.primary.section_image_caption),
				          index: i
				        })
						  }
						  
						  else if (slice.slice_type == 'carousel') {
							  
							  for (var [x, item] of slice.items.entries()) {
									
									this.items.push({
					          src: item.slide_image.url,
					          w: item.slide_image.dimensions.width,
					          h: item.slide_image.dimensions.height,
					          title: prismicDOM.RichText.asHtml(item.slide_caption, innerSingleParagraph),
					          index: i.x
					        })
								}
						  }
						  
						  else if (slice.slice_type == 'image_grid') {
							  
							  for (var [x, item] of slice.items.entries()) {
									
									this.items.push({
					          src: item.grid_image.url,
					          w: item.grid_image.dimensions.width,
					          h: item.grid_image.dimensions.height,
					          title: prismicDOM.RichText.asHtml(item.grid_image_caption, innerSingleParagraph),
					          index: i.x
					        })
								}
						  }
						  
						}
            } catch (error) {
                this.$router.push({ name: 'not-found' })
            }
        },

        sanitizeTitle (title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
      // Letter "d"
      slug = slug.replace(/đ/gi, 'd');
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, '');
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, '-');
      
      return slug;
    },
    },

    created () {
        this.getContent();

    },

    mounted() {
        this.mounted = true;
    },

    
    beforeRouteUpdate (to, from, next) {
	    this.items = []
        this.getContent(to.params.uid)
        next()
    }
}
</script>

<style>
    

    #telethon h3, #telethon h2, #telethon p {
        font-family: "Helvetica-Rounded";
    }

    #telethon strong {
        font-family: "Plain-Bold" !important;
    }

    .tv-test-card {
        display: flex;
        width: 100%;
    }

    .tv-test-card div {
        width: 14.30%;
        height: 48px;
        z-index: 200;
    }

    #black {
        background-color: #000000;
    }

    #red {
        background-color: #FF0000;
    }

    #pink {
        background-color: #FF00FF;
    }

    #green {
        background-color: #00FF00;
    }

    #blue {
        background-color: #00FFFF;
    }

    #yellow {
        background-color: #FFFF00;
    }

    #white {
        background-color: #FFF;
    }

    .title-container {
        background-color: blue;
        position: relative;
    }

    .overlay-container {
        height: 90%;
        position: absolute;
        z-index: 200;
        display: flex;
        flex-direction: column;
        background: rgba(0,255,0,0.00);
        border: 3px solid #3CFF00;
        box-shadow: 0 0 16px 1px #00FF00;
        border-radius: 71px;
        margin: 32px;
        color: white;
    }

    .grow-subtle {
        animation: grow-subtle 2s infinite;
    }


    .title-container .overlaid-text, .title-container img, .title-container h2 {
        position: relative;
    }

    .title-container .overlaid-text {
        top: 32px;
        text-align: center;
        font-size: 2.5vmax;
    }

    .title-container img.overlay {
        margin: 0 auto;
        top: 96px;
        width: 60%;
        transform: translateY(-50%); 
    }

    .title-container h2 {
        text-align: center;
        top: 116px;
        color: #00FF00;
        text-transform: uppercase;
        font-weight: normal;
        font-size: 2.5vmax;
        text-shadow: 0 0 16px 1px #00FF00 !important;
    }

    .title-container figure, .section-info figure {
        width: 100%;
        background-color: blue;
    }

    .title-container figure img, .section-info figure img {
        mix-blend-mode: darken;
    }

    .black-ticker {
        background-color: black;
    }

    .blue-ticker {
        background-color: blue;
    }

    .ticker .white {
        font-family: Helvetica;
        font-size: 32px;
        color: #FFF;
        letter-spacing: -1px;
        text-align: center;
    }

    .ticker .blue {
        font-family: Helvetica;
        font-size: 32px;
        color: #0000FF;
        letter-spacing: -1px;
        text-align: center;
    }

    .ticker .blue:before {
        content: " • "; 

    }

    .credits {
        background-color: black;
        color: white;
        padding: 46px;
        position: relative;
        display: flex;
        align-items: center;
    }

    /* .credits div:first-child {
        /* margin-left: 96px;
    } */

    .credits div {
        width: 60%;
        margin-left: 32px;
    }

    .credits div h2:nth-child(2) {
        margin-top: 16px;
        color:#00FF00;
        border-top: 1px solid #00FF00;
    }

    /* .section-info::before {
        content: 'Join The Committee';
        position: absolute;
        background-color: white;
        padding: 16px;
        z-index: 400;
        color: black;
        border: 3px solid #FFF !important;
        box-shadow: 0 0 16px 1px #FFF !important;
        border-radius: 10px;
        /* left: 45%; 
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 160px;
        text-align: center;
        cursor: pointer;
    } */

    .section-info {
        background-color: blue;
        max-width: 100vw;  
        height: 100%;   
    }

    .section-info figure {
        height: 100vh;
        position: sticky;
        position: -webkit-sticky;
        top: 0;
        padding: 0;
    }

    .section-info figure img {
        /* top: 0; */
        /* width: 100%;     */
        height: 100%;
        object-fit: cover;   
        padding: 0;
    }

    .sticky .page-content {
        color: white; 
        /* height: 100%; */
    }

    .sticky .page-content h1, .sticky .page-content h2, .sticky .page-content strong, .sticky .page-content a {
        color: #00FF00;
    }

    .sticky .page-content h1 strong em, .sticky .page-content h2 strong em, .sticky .page-content .text p strong em {
        font-style: normal !important;
        text-shadow: 5px 0px 16px #00FF00;
        display: block;
    }

    .sticky .page-content .text p strong em {
        font-size: 2.5vmax;
    }

    .sticky .page-content article hr {
        margin: 32px 0px;
        border-bottom: 2px solid #00FF00;
        box-shadow: 0 0 16px 2px #00FF00;
    }

    .sticky .page-content .text p strong em {
        margin: 16px 0px;
    }



    .sticky .page-content a:not(.btn) {
        border-bottom: 1px solid #00FF00; 
    }

    .sticky .page-content a:hover {
        text-decoration: none;
        color: #FF001F;
        transition: all 500ms cubic-bezier(0.57, 0.06, 0.05, 0.95);
    }

    .sticky .page-content .cta .btn, .sticky .page-content .btn {
        font-family: 'Helvetica-Rounded';
        background-color: #00FF00;
        color: black;
        border: 3px solid #00FF00;
        box-shadow: 0 0 16px 1px #00FF00;
        margin: 32px 32px 32px 0px;
        text-align: center;
    }

    .sticky .page-content .text div ul {
        padding-left: 24px;
    }

    .footer-info {
        background-color: black;
        color: white;
        padding: 8px 0px;
    }
    

    .footer-info .wrap h2 {
        color: #00FF00;
        padding-bottom: 8px;
        position: relative;
        display: inline;
    }

    .footer-info .wrap h2::after {
        position: absolute;
        bottom: 0; 
        left: 0; 
        width: 100%; 
        height: 1px; 
        border-bottom: 1px solid #00FF00; 
        content: ""
    }

    .footer-info .wrap p {
        margin: 32px 64px 32px 0px;
    }

    .footer-info .wrap:first-child {
        border-right: 3px solid #FFDC00;
    }

    @media (max-width: 930px) {
        .credits div:last-child h3 {
            padding-bottom: 24px;
        }
    }

    @media (max-width: 768px) {

        .overlay-container {
            height: 95%;
            margin: 8px;
        }

        .title-container .overlaid-text {
            top: 32px;
            font-size: 16px;
            text-align: center;
            margin: 16px;
        }

        .title-container img.overlay {
            margin: 0 auto;
            top: 64px;
            width: 90%; 
            padding: 0;
        }

        .title-container h2 {
            text-align: center;
            font-size: 18px;
            top: 90px;
            color: #00FF00;
            text-transform: uppercase;
            font-weight: 800;
        }


        .credits {
            width: 100vw;
            height: 100%;
            display: grid;
            padding: 0;
            margin: 0;
            grid-template-columns: 100% !important;
        }

        

    
        .credits div {
            margin: 32px 32px;
            padding: 0px;
            width: 100%;
        }

       .credits div:first-child {
            margin-left:  32px;
        }

        .credits div:last-child {
            margin-left:  32epx;
        } 

        .credits div:last-child h3 {
            padding-bottom: 0px;
        } 

        .credits div h2 {
            padding-bottom: 8px;
            position: relative;
            display: inline;
        }

        .credits div h2:before {
            position: absolute;
            top: 0; 
            left: 0; 
            width: 100%; 
            height: 1px; 
            border-bottom: 1px solid #00FF00; 
            content: ""
        }

        

        .credits div h2:nth-child(2) {
            /* font-size: 14px; */
            /* margin-top: 16px; */
            color:#00FF00;
            border-top: none;
        }


       /* .credits div h3 {
            font-size: 10px;
        } */

        .section-info::before {
            display: none;
        }

        .section-info {
            width: 100vw;
            height: 100%;
            display: grid;
            grid-template-columns: 100% !important;
        }


        .section-info figure {
            position: relative;
            height: 50vh;
        }

        .section-info figure img {
            width: 100%;
            position: relative;
            
        }

        .sticky .page-content .text p strong em {
            font-size: 4vmax;
        }

        .footer-info {
            background-color: black;
            color: white;
            display: grid;
            padding: 0px 8px;
            grid-template-columns: 100% !important;
        }

        .footer-info div {
            text-align: center;
        }
    
        .footer-info .wrap p {
            margin: 32px auto;
        }

        .footer-info .wrap:first-child {
            border-right: none;
            border-bottom: 3px solid #FFDC00;
        }
    } 

    @media (max-width: 414px) {
        .page-content {
            padding: 0;
        }
    }

    @keyframes grow-subtle {
        0% {
            -webkit-transform: scale(1);
            -moz-transform: scale(1);
            transform: scale(1);
        }
        50% {
            -webkit-transform: scale(0.95);
            -moz-transform: scale(0.95);
            transform: scale(0.95);
        }
        100% {
            -webkit-transform: scale(1);
            -moz-transform: scale(1);
            transform: scale(1);
        }
    }
</style>

